<div 
  class="ui-g container fundo-branco">
  <div class="ui-lg-2 ui-g-2 ui-m-3 ui-sm-3 fila-release-note">
    <app-release-note-fila
      (abrirReleaseNoteEventEmitter)=abrirReleaseNoteEventEmitter($event)
      [releaseNoteSelecionado]="releaseNoteSelecionado"
      [releaseNotes]="releaseNotes"></app-release-note-fila>
  </div>

  <div class="ui-lg-10 ui-g-10 ui-m-9 ui-sm-9 container-release-note">
    <app-release-note
     [releaseNote]="releaseNoteSelecionado"></app-release-note>
  </div>
</div>
